import styled from 'styled-components';

const SCPdfBankStatementLogos = styled.div`
  max-width: 420px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

export const PdfBankStatementLogos = () => {
  return (
    <SCPdfBankStatementLogos>
      <img src="/bank-logos/au/anz.png" alt="ANZ" />
      <img src="/bank-logos/au/cba.png" alt="Commonwealth Bank" />
      <img src="/bank-logos/au/nab.png" alt="NAB" />
      <img src="/bank-logos/au/westpac.png" alt="Westpac" />
      <img src="/bank-logos/au/amex.png" alt="American Express" />
      <img src="/bank-logos/au/bank-australia.png" alt="Bank Australia" />
      <img src="/bank-logos/au/bom.png" alt="Bank of Melbourne" />
      <img src="/bank-logos/au/banksa.png" alt="BankSA" />
      <img src="/bank-logos/au/bankwest.png" alt="Bankwest" />
      <img src="/bank-logos/au/bendigo.png" alt="Bendigo Bank" />
      <img src="/bank-logos/au/beyond-bank.png" alt="Beyond Bank" />
      <img src="/bank-logos/au/boq.png" alt="Bank of Queensland" />
      <img src="/bank-logos/au/cua.png" alt="Great Southern Bank" />
      <img src="/bank-logos/au/greater-bank.png" alt="Greater Bank" />
      <img src="/bank-logos/au/heritage.png" alt="Heritage Bank" />
      <img src="/bank-logos/au/ing.png" alt="ING Direct" />
      <img src="/bank-logos/au/newcastle-permanent.png" alt="Newcastle Permanent" />
      <img src="/bank-logos/au/peoples-choice.png" alt="People's Choice" />
      <img src="/bank-logos/au/queensland-country-bank.png" alt="Queensland Country Bank" />
      <img src="/bank-logos/au/stgeorge.png" alt="St.George" />
      <img src="/bank-logos/au/suncorp.png" alt="Suncorp Bank" />
      <img src="/bank-logos/au/unity-bank.png" alt="Unity Bank" />
      <img src="/bank-logos/au/reliance-bank.png" alt="Reliance Bank" />
      <img src="/bank-logos/au/bankstown-city-unity-bank.png" alt="Bankstown City Unity Bank" />
      <img src="/bank-logos/au/credit-union-sa.png" alt="Credit Union SA" />
      <img src="/bank-logos/au/macquarie.png" alt="Macquarie Bank" />
    </SCPdfBankStatementLogos>
  );
};
